<template>
  <span>
    <p>Versão: 07 de fevereiro de 2021</p>
    <span>
      <p v-if="termsAcceptedAt">
        Aceito em: {{ $dayjs(termsAcceptedAt).format('DD/MM/YYYY') }}
      </p>
      <h2>Termos e condições gerais de uso do sistema Web Farm</h2>
      <p>
        Os serviços do sistema são fornecidos pela pessoa jurídica com a
        seguinte Razão Social: Maximino e Soares Tecnologia em Software LTDA,
        com nome fantasia Coderoom Solutions, inscrito no CNPJ sob o nº
        39.447.457/0001-84, titular da propriedade intelectual sobre software,
        website, aplicativos, conteúdos e demais ativos relacionados à
        plataforma Web Farm.
      </p>

      <h3>1. Do objeto</h3>
      <p>
        A plataforma visa licenciar o uso de seu software, website, aplicativos
        e demais ativos de propriedade intelectual, fornecendo ferramentas para
        auxiliar e dinamizar o dia a dia dos seus usuários.
        <br />
        A plataforma caracteriza-se pela prestação do seguinte serviço:
        Informatizar fazendas através do cadastro de bovinos, serviços, lotes,
        fazendas, entre outros dados existentes na realidade do usuário.
        <br />
        A plataforma realiza a venda à distância por meio eletrônico dos
        seguintes produtos ou serviços: Adesão aos planos Web Farm Lite, Web
        Farm Plus ou Web Farm Black.
      </p>

      <h3>2. Da aceitação</h3>
      <p>
        O presente Termo estabelece obrigações contratadas de livre e espontânea
        vontade, por tempo indeterminado, entre a plataforma e as pessoas
        físicas ou jurídicas, usuárias do sistema, site ou aplicativo.
        <br />
        Ao utilizar a plataforma o usuário aceita integralmente as presentes
        normas e compromete-se a observá-las, sob o risco de aplicação das
        penalidades cabíveis.
        <br />
        A aceitação do presente instrumento é imprescindível para o acesso e
        para a utilização de quaisquer serviços fornecidos pela empresa. Caso
        não concorde com as disposições deste instrumento, o usuário não deve
        utilizá-los.
      </p>

      <h3>3. Do acesso dos usuários</h3>
      <p>
        Serão utilizadas todas as soluções técnicas à disposição do responsável
        pela plataforma para permitir o acesso ao serviço 24 (vinte e quatro)
        horas por dia, 7 (sete) dias por semana. No entanto, a navegação na
        plataforma ou em alguma de suas páginas poderá ser interrompida,
        limitada ou suspensa para atualizações, modificações ou qualquer ação
        necessária ao seu bom funcionamento.
      </p>

      <h3>4. Do cadastro</h3>
      <p>
        O acesso às funcionalidades da plataforma exigirá a realização de um
        cadastro prévio e, a depender dos serviços ou produtos escolhidos, o
        pagamento de determinado valor.
        <br />
        Ao se cadastrar o usuário deverá informar dados completos, recentes e
        válidos, sendo de sua exclusiva responsabilidade manter referidos dados
        atualizados, bem como o usuário se compromete com a veracidade dos dados
        fornecidos.
        <br />
        O usuário se compromete a não informar seus dados cadastrais e/ou de
        acesso à plataforma a terceiros, responsabilizando-se integralmente pelo
        uso que deles seja feito.
        <br />
        Menores de 18 anos e aqueles que não possuírem plena capacidade civil
        deverão obter previamente o consentimento expresso de seus responsáveis
        legais para utilização da plataforma e dos serviços ou produtos, sendo
        de responsabilidade exclusiva dos mesmos o eventual acesso por menores
        de idade e por aqueles que não possuem plena capacidade civil sem a
        prévia autorização.
        <br />
        Mediante a realização do cadastro o usuário declara e garante
        expressamente ser plenamente capaz, podendo exercer e usufruir
        livremente dos serviços e produtos.
        <br />
        O usuário deverá fornecer um endereço de e-mail válido, através do qual
        o sistema realizará todas as comunicações necessárias. Após a
        confirmação do cadastro, o usuário possuirá um login e uma senha
        pessoal, a qual assegura ao usuário o acesso individual à mesma. Desta
        forma, compete ao usuário exclusivamente a manutenção de referida senha
        de maneira confidencial e segura, evitando o acesso indevido às
        informações pessoais.
        <br />
        Toda e qualquer atividade realizada com o uso da senha será de
        responsabilidade do usuário, que deverá informar prontamente a
        plataforma em caso de uso indevido da respectiva senha.
        <br />
        Não será permitido ceder, vender, alugar ou transferir, de qualquer
        forma, a conta, que é pessoal e intransferível. Caberá ao usuário
        assegurar que o seu equipamento seja compatível com as características
        técnicas que viabilize a utilização da plataforma e dos serviços ou
        produtos.
        <br />
        O usuário poderá, a qualquer tempo, requerer o cancelamento de seu
        cadastro junto ao sistema Web Farm. O seu descadastramento será
        realizado o mais rapidamente possível, desde que não sejam verificados
        débitos em aberto. O usuário, ao aceitar os Termos e Política de
        Privacidade, autoriza expressamente a plataforma a coletar, usar,
        armazenar, tratar, ceder ou utilizar as informações derivadas do uso dos
        serviços, do sistema e quaisquer plataformas, incluindo todas as
        informações preenchidas pelo usuário no momento em que realizar ou
        atualizar seu cadastro, além de outras expressamente descritas na
        Política de Privacidade que deverá ser autorizada pelo usuário.
      </p>

      <h3>5. Dos serviços ou produtos</h3>
      <p>
        A plataforma poderá disponibilizar para o usuário um conjunto específico
        de funcionalidades e ferramentas para otimizar o uso dos serviços e
        produtos.
        <br />
        Na plataforma os serviços ou produtos oferecidos estão descritos e
        apresentados com o maior grau de exatidão, contendo informações sobre
        suas características, qualidades, quantidades, composição, preço,
        garantia, prazos de validade e origem, entre outros dados, bem como
        sobre os riscos que apresentam à saúde e segurança do usuário.
        <br />
        Antes de finalizar a compra sobre determinado produto ou serviço, o
        usuário deverá se informar sobre as suas especificações e sobre a sua
        destinação.
        <br />
        A entrega de serviços ou produtos adquiridos na plataforma será
        informada no momento da finalização da compra.
      </p>

      <h3>6. Dos preços</h3>
      <p>
        A plataforma se reserva no direito de reajustar unilateralmente, a
        qualquer tempo, os valores dos serviços ou produtos sem consulta ou
        anuência prévia do usuário.
        <br />
        Os valores aplicados são aqueles que estão em vigor no momento do
        pedido.
        <br />
        Os preços são indicados em reais.
        <br />
        Na contratação de determinado serviço ou produto, a plataforma poderá
        solicitar as informações financeiras do usuário, como CPF ou CNPJ,
        endereço de cobrança. Ao inserir referidos dados o usuário concorda que
        sejam cobrados, de acordo com a forma de pagamento que venha a ser
        escolhida, os preços então vigentes e informados quando da contratação.
        Referidos dados financeiros poderão ser armazenados para facilitar
        acessos e contratações futuras.
        <br />
        A contratação dos serviços será renovada automaticamente pela
        plataforma, independentemente de comunicação ao usuário, mediante
        cobrança periódica da mesma forma de pagamento indicada pelo usuário
        quando da contratação do serviço.
      </p>

      <h3>7. Do cancelamento</h3>
      <p>
        O usuário poderá cancelar a contratação dos serviços de acordo com os
        termos que forem definidos no momento de sua contratação. Ainda, o
        usuário também poderá cancelar os serviços em até 7 (sete) dias após a
        contratação, mediante contato com a administração da empresa, de acordo
        com o Código de Defesa do Consumidor (Lei no. 8.078/90).
        <br />
        O serviço poderá ser cancelado por:
        <br />
        a) Parte do usuário: nessas condições os serviços somente cessarão
        quando concluído o ciclo vigente ao tempo do cancelamento;
        <br />
        b) Violação dos Termos de Uso: os serviços serão cessados imediatamente.
        <br />
        c) Inadimplência do pagamento: os serviços poderão ser temporariamente
        bloqueados caso o usuário apresente uma pendência no pagamento por mais
        de 14 dias.
      </p>

      <h3>9. Do suporte</h3>
      <p>
        Em caso de qualquer dúvida, sugestão ou problema com a utilização da
        plataforma, o usuário poderá entrar em contato com o suporte, através do
        email contato@coderoomsolutions.com.br OU telefone (44) 9 9858-1892.
        <br />
        Estes serviços de atendimento ao usuário estarão disponíveis nos
        seguintes dias e horários: segunda a sexta-feira entre 10:00 e 16:00.
      </p>

      <h3>10. Das responsabilidades</h3>
      <p>
        É de responsabilidade do usuário: <br />
        a) A correta utilização da plataforma, dos serviços ou produtos
        oferecidos; <br />
        b) pelo cumprimento e respeito ao conjunto de regras disposto nesse
        Termo de Condições Geral de Uso, na respectiva Política de Privacidade e
        na legislação nacional e internacional; <br />
        c) pela proteção aos dados de acesso à sua conta/perfil (login e senha).
        <br />
      </p>
      <p>
        É de responsabilidade da plataforma Web Farm:
        <br />
        a) Indicar as características do serviço ou produto;
        <br />
        b) Os defeitos e vícios encontrados no serviço ou produto oferecido
        desde que lhe tenha dado causa;
        <br />
        c) As informações que foram por ele divulgadas, sendo que os comentários
        ou informações divulgadas por usuários são de inteira responsabilidade
        dos próprios usuários;
        <br />
        d) Os conteúdos ou atividades ilícitas praticadas através da sua
        plataforma.
        <br />
        A plataforma não se responsabiliza por links externos contidos em seu
        sistema que possam redirecionar o usuário à ambiente externo a sua rede.
        Não poderão ser incluídos links externos ou páginas que sirvam para fins
        comerciais ou publicitários ou quaisquer informações ilícitas,
        violentas, polêmicas, pornográficas, xenofóbicas, discriminatórias ou
        ofensivas.
      </p>

      <h3>11. Dos direitos autorais</h3>
      <p>
        O presente Termo de Uso concede aos usuários uma licença não exclusiva,
        não transferível e não sublicenciável, para acessar e fazer uso da
        plataforma e dos serviços e produtos por ela disponibilizados.
        <br />
        A estrutura do site ou aplicativo, as marcas, logotipos, nomes
        comerciais, layouts, gráficos e design de interface, imagens,
        ilustrações, fotografias, apresentações, vídeos, conteúdos escritos e de
        som e áudio, programas de computador, banco de dados, arquivos de
        transmissão e quaisquer outras informações e direitos de propriedade
        intelectual da razão social Maximino e Soares Tecnologia em Software
        LTDA, observados os termos da Lei da Propriedade Industrial (Lei nº
        9.279/96), Lei de Direitos Autorais (Lei nº 9.610/98) e Lei do Software
        (Lei nº 9.609/98), estão devidamente reservados.
        <br />
        Este Termo de Uso não cede ou transfere ao usuário qualquer direito, de
        modo que o acesso não gera qualquer direito de propriedade intelectual
        ao usuário, exceto pela licença limitada ora concedida.
        <br />
        O uso da plataforma pelo usuário é pessoal, individual e intransferível,
        sendo vedado qualquer uso não autorizado, comercial ou não-comercial.
        Tais usos consistirão em violação dos direitos de propriedade
        intelectual da razão social Maximino e Soares Tecnologia em Software
        LTDA, puníveis nos termos da legislação aplicável.
      </p>

      <h3>12. Das sanções</h3>
      <p>
        Sem prejuízo das demais medidas legais cabíveis, a razão social Maximino
        e Soares Tecnologia em Software LTDA poderá, a qualquer momento,
        advertir, suspender ou cancelar a conta do usuário:
        <br />
        a) que violar qualquer dispositivo do presente Termo;
        <br />
        b) que descumprir os seus deveres de usuário;
        <br />
        c) que tenha qualquer comportamento fraudulento ou doloso.
      </p>

      <h3>13. Da rescisão</h3>
      <p>
        A não observância das obrigações pactuadas neste Termo de Uso ou da
        legislação aplicável poderá, sem prévio aviso, ensejar a imediata
        rescisão unilateral por parte da razão social Maximino e Soares
        Tecnologia em Software LTDA e o bloqueio de todos os serviços prestados
        ao usuário.
      </p>

      <h3>14. Das alterações</h3>
      <p>
        Os itens descritos no presente instrumento poderão sofrer alterações,
        unilateralmente e a qualquer tempo, por parte da Maximino e Soares
        Tecnologia em Software LTDA, para adequar ou modificar os serviços, bem
        como para atender novas exigências legais. As alterações serão
        veiculadas pelo site wfarm.com e o usuário poderá optar por aceitar o
        novo conteúdo ou por cancelar o uso dos serviços, caso seja assinante de
        algum serviço.
        <br />
        Os serviços oferecidos podem, a qualquer tempo e unilateralmente, e sem
        qualquer aviso prévio, ser deixados de fornecer, alterados em suas
        características, bem como restringido para o uso ou acesso.
      </p>

      <h3>15. Da política de privacidade</h3>
      <p>
        Além do presente Termo, o usuário deverá consentir com as disposições
        contidas na respectiva Política de Privacidade a ser apresentada a todos
        os interessados dentro da interface da plataforma.
      </p>

      <h3>16. Do foro</h3>
      <p>
        Para a solução de controvérsias decorrentes do presente instrumento será
        aplicado integralmente o Direito brasileiro.
        <br />
        Os eventuais litígios deverão ser apresentados no foro da comarca em que
        se encontra a sede da empresa.Os eventuais litígios deverão ser
        apresentados no foro da comarca em que se encontra a sede da empresa.
      </p>
    </span>
    <br /><br />
    <span>
      <h2>Política de privacidade do sistema Web Farm</h2>
      <h3>SEÇÃO 1 - INFORMAÇÕES GERAIS</h3>
      <p>
        A presente Política de Privacidade contém informações sobre coleta, uso,
        armazenamento, tratamento e proteção dos dados pessoais dos usuários do
        aplicativo e site Web Farm, com a finalidade de demonstrar absoluta
        transparência quanto ao assunto e esclarecer a todos interessados sobre
        os tipos de dados que são coletados, os motivos da coleta e a forma como
        os usuários podem gerenciar ou excluir as suas informações pessoais.
        <br />
        Esta Política de Privacidade aplica-se a todos os usuários do aplicativo
        e site Web Farm e integra os Termos e Condições Gerais de Uso do
        aplicativo e site Web Farm, devidamente inscrita no CNPJ sob o nº
        39.447.457/0001-84, situado em Rua Aracaju, 176 - Campo Mourão - PR,
        doravante denominada Coderoom Solutions.
        <br />
        O presente documento foi elaborado em conformidade com a Lei Geral de
        Proteção de Dados Pessoais (Lei 13.709/18), o Marco Civil da Internet
        (Lei 12.965/14) (e o Regulamento da UE n. 2016/6790). Ainda, o documento
        poderá ser atualizado em decorrência de eventual atualização normativa,
        razão pela qual se convida o usuário a consultar periodicamente esta
        seção.
      </p>

      <h3>SEÇÃO 2 - COMO RECOLHEMOS OS DADOS PESSOAIS DO USUÁRIO?</h3>
      <p>
        Os dados pessoais do usuário são recolhidos pela plataforma da seguinte
        forma:
        <br />
        1. Quando o cliente solicita a criação de uma conta na plataforma Web
        Farm: esses dados são os dados de identificação básicos, como nome
        completo, CPF ou CNPJ e telefone ou celular. A partir deles, podemos
        cadastrar uma conta no sistema.
        <br />
        2. Quando o usuário cadastra usuários na plataforma Web Farm: esses
        dados são os dados de identificação básicos, como username, e-mail,
        telefone ou celular e nome completo. A partir deles, podemos identificar
        o usuário e o visitante, além de garantir uma maior segurança e
        bem-estar às suas necessidades.
        <br />
        3. Quando um usuário acessa as páginas do site e aplicativo Web Farm, as
        informações sobre interação e acesso são coletadas pela empresa para
        garantir uma melhor experiência ao usuário. Estes dados podem tratar
        sobre as palavras-chaves utilizadas em uma busca, visualizações de
        páginas, perfis, a URL de onde o usuário e visitante provêm, o navegador
        que utilizam e seus IPs de acesso, dentre outras que poderão ser
        armazenadas e retidas.
      </p>

      <h3>SEÇÃO 3 - QUAIS DADOS PESSOAIS RECOLHEMOS SOBRE O USUÁRIO?</h3>
      <p>
        Os dados pessoais do usuário e visitante recolhidos são os seguintes:
        <br />
        1. Dados para a criação da conta na plataforma Web Farm: nome completo,
        CPF ou CNPJ e telefone ou celular.
        <br />
        2. Dados para a criação de usuário na plataforma Web Farm: username,
        e-mail, telefone ou celular e nome completo.
        <br />
        3. Dados para otimização da navegação: Acesso a páginas, palavras-chave
        utilizadas na busca, interação na plataforma, endereço de IP.
      </p>

      <h3>
        SEÇÃO 4 - PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO?
      </h3>
      <p>
        Os dados pessoais do usuário e do visitante coletados e armazenados pela
        plataforma Web Farm tem por finalidade:
        <br />
        1. Bem-estar do usuário: aprimorar o produto e/ou serviço oferecido,
        facilitar, agilizar e cumprir os compromissos estabelecidos entre o
        usuário e a empresa, melhorar a experiência dos usuários e fornecer
        funcionalidades específicas a depender das características básicas do
        usuário.
        <br />
        2. Melhorias da plataforma: compreender como o usuário utiliza os
        serviços da plataforma, para ajudar no desenvolvimento de negócios e
        técnicas.
        <br />
        3. Comercial: os dados são usados para personalizar o conteúdo oferecido
        e gerar subsídio à plataforma para a melhora da qualidade no
        funcionamento dos serviços.
        <br />
        4. Previsão do perfil do usuário: tratamento automatizado de dados
        pessoais para avaliar o uso na plataforma.
        <br />
        5. Dados de cadastro: para permitir o acesso do usuário a determinados
        conteúdos da plataforma.
        <br />
        6. Dados de contrato: conferir às partes segurança jurídica e facilitar
        a conclusão do negócio.
        <br />
        O tratamento de dados pessoais para finalidades não previstas nesta
        Política de Privacidade somente ocorrerá mediante comunicação prévia ao
        usuário, de modo que os direitos e obrigações aqui previstos permanecem
        aplicáveis.
      </p>

      <h3>SEÇÃO 5 - POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS?</h3>

      <p>
        Os dados pessoais da conta e do usuário são armazenados pela plataforma
        durante o período necessário para a prestação do serviço ou o
        cumprimento das finalidades previstas no presente documento, conforme o
        disposto no inciso I do artigo 15 da Lei 13.709/18.
        <br />
        Os dados podem ser removidos ou anonimizados a pedido do usuário,
        excetuando os casos em que a lei oferecer outro tratamento.

        <br />
        Ainda, os dados pessoais dos usuários apenas podem ser conservados após
        o término de seu tratamento nas seguintes hipóteses previstas no artigo
        16 da referida lei:
        <br />
        I - cumprimento de obrigação legal ou regulatória pelo controlador;
        <br />
        II - estudo por órgão de pesquisa, garantida, sempre que possível, a
        anonimização dos dados pessoais;
        <br />
        III - transferência a terceiro, desde que respeitados os requisitos de
        tratamento de dados dispostos nesta Lei;
        <br />
        IV - uso exclusivo do controlador, vedado seu acesso por terceiro, e
        desde que anonimizados os dados.
      </p>

      <h3>SEÇÃO 6 - SEGURANÇA DOS DADOS PESSOAIS ARMAZENADOS</h3>

      <p>
        A plataforma se compromete a aplicar as medidas técnicas e organizativas
        aptas a proteger os dados pessoais de acessos não autorizados e de
        situações de destruição, perda, alteração, comunicação ou difusão de
        tais dados.
        <br />
        A plataforma não se exime de responsabilidade por culpa exclusiva de
        terceiro, como em caso de ataque de hackers ou crackers, ou culpa
        exclusiva do usuário, como no caso em que ele mesmo transfere seus dados
        a terceiros. O site compromete- se a comunicar o usuário em caso de
        alguma violação de segurança dos seus dados pessoais.
        <br />

        Os dados pessoais armazenados são tratados com confidencialidade, dentro
        dos limites legais. No entanto, podemos divulgar suas informações
        pessoais caso sejamos obrigados pela lei para fazê-lo ou se você violar
        nossos Termos de Serviço.
      </p>

      <h3>SEÇÃO 7 - COMPARTILHAMENTO DOS DADOS</h3>
      <p>
        Os dados do perfil do usuário e da conta são compartilhados somente no
        domínio da conta e somente dentro da plataforma, seus dados não aparecem
        em resultados de busca de ferramentas de pesquisas.
      </p>

      <h3>
        SEÇÃO 8 - OS DADOS PESSOAIS ARMAZENADOS SERÃO TRANSFERIDOS A TERCEIROS?
      </h3>
      <p>
        Os dados pessoais somente podem ser compartilhados com terceiros com a
        finalidade de processamento de transação de pagamento como as seguintes
        pessoas: Banco Inter S/A 00.416.968/0001-01.
        <br />
        Os terceiros indicados recebem os dados na medida do necessário para
        permitir que eles realizem os serviços contratados.
        <br />
        Com relação aos fornecedores de serviços terceirizados como
        processadores de transação de pagamento, informamos que cada qual tem
        sua própria política de privacidade. Desse modo, recomendamos a leitura
        das suas políticas de privacidade para compreensão de quais informações
        pessoais serão usadas por esses fornecedores.
        <br />
        Os fornecedores podem ser localizados ou possuir instalações localizadas
        em países diferentes. Nessas condições, os dados pessoais transferidos
        podem se sujeitar às leis de jurisdições nas quais o fornecedor de
        serviço ou suas instalações estão localizados.
        <br />
        Ao acessar nossos serviços e prover suas informações, você está
        consentindo o processamento, transferência e armazenamento desta
        informação em outros países.
        <br />
        Ao ser redirecionado para um aplicativo ou site de terceiros, você não
        será mais regido por essa Política de Privacidade ou pelos Termos de
        Serviço da nossa plataforma. Não somos responsáveis pelas práticas de
        privacidade de outros sites e lhe incentivamos a ler as declarações de
        privacidade deles.
      </p>

      <h3>SEÇÃO 9 – COOKIES OU DADOS DE NAVEGAÇÃO</h3>
      <p>
        Os cookies referem-se a arquivos de texto enviados pela plataforma ao
        computador do usuário e visitante e que nele ficam armazenados, com
        informações relacionadas à navegação no site. Tais informações são
        relacionadas aos dados de acesso como local e horário de acesso e são
        armazenadas pelo navegador do usuário e visitante para que o servidor da
        plataforma possa lê-las posteriormente a fim de personalizar os serviços
        da plataforma.
        <br />
        O usuário e o visitante da plataforma Web Farm manifesta conhecer e
        aceitar que pode ser utilizado um sistema de coleta de dados de
        navegação mediante a utilização de cookies.
        <br />
        O cookie persistente permanece no disco rígido do usuário depois que o
        navegador é fechado e será usado pelo navegador em visitas subsequentes
        ao site. Os cookies persistentes podem ser removidos seguindo as
        instruções do seu navegador. Já o cookie de sessão é temporário e
        desaparece depois que o navegador é fechado. É possível redefinir seu
        navegador da web para recusar todos os cookies, porém alguns recursos da
        plataforma podem não funcionar corretamente se a capacidade de aceitar
        cookies estiver desabilitada.
      </p>

      <h3>SEÇÃO 10 - CONSENTIMENTO</h3>
      <p>
        Ao utilizar os serviços e fornecer as informações pessoais na
        plataforma, o usuário está consentindo com a presente Política de
        Privacidade.
        <br />
        O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus
        direitos de cancelar seu cadastro, acessar e atualizar seus dados
        pessoais e garante a veracidade das informações por ele
        disponibilizadas.
        <br />
        O usuário tem direito de retirar o seu consentimento a qualquer tempo,
        para tanto deve entrar em contato através do e-mail
        administacao@coderoomsolutions.com.br ou por correio enviado ao seguinte
        endereço: Rua Aracaju, 176 - Campo Mourão - PR.
      </p>

      <h3>SEÇÃO 11 - ALTERAÇÕES PARA ESSA POLÍTICA DE PRIVACIDADE</h3>
      <p>
        Reservamos o direito de modificar essa Política de Privacidade a
        qualquer momento, então, é recomendável que o usuário revise-a com
        frequência.
        <br />
        As alterações e esclarecimentos vão surtir efeito imediatamente após sua
        publicação na plataforma. Quando realizadas alterações os usuários serão
        notificados. Ao utilizar o serviço ou fornecer informações pessoais após
        eventuais modificações, o usuário e visitante demonstra sua concordância
        com as novas normas.
        <br />
        Diante da fusão ou venda da plataforma à outra empresa os dados dos
        usuários podem ser transferidos para os novos proprietários para que a
        permanência dos serviços oferecidos.
      </p>

      <h3>SEÇÃO 12 – JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS</h3>
      <p>
        Para a solução de controvérsias decorrentes do presente instrumento será
        aplicado integralmente o Direito brasileiro.
        <br />
        Os eventuais litígios deverão ser apresentados no foro da comarca em que
        se encontra a sede da empresa.
      </p>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UseTermText',
  props: {
    termsAcceptedAt: String,
  },
};
</script>

<style scoped>
h3 {
  font-size: 1.3rem;
}

span {
  text-align: justify;
  text-justify: inter-word;
}
</style>